import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'tog-remaining-text-indicator',
  templateUrl: './remaining-text-indicator.component.html',
  styleUrls: ['./remaining-text-indicator.component.scss']
})
export class RemainingTextIndicatorComponent implements OnInit {
  @Input() value: string = '';
  @Input() maxCharacters: number = 50;
  @Input() warningLimit: number = 10;

  constructor() { }

  ngOnInit() {
  }

  get charactersLeft() {
    if (!this.value) return this.maxCharacters;
    return this.maxCharacters - this.value.length;
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/remaining-text-indicator/remaining-text-indicator.component.ts